import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
@font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 

  .generated-images-holder-var29 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1351px;
  }
  .image-holder-var29 {
    width: 100%;
    display: flex;
    position: relative;
    flex: 1;
    min-height: 0;
  }

  .holder-inner-var29 {
    height: 1004px;
    display: flex;
    flex-direction: column;
  }

  .left-div-var29, .right-div-var29 {
    width: 50%;
    position: relative;
  }

  .top-text-var29 {
    width: 100%;
    background-color: white;
    padding: 27px 47px 22px;
    font-size: 85px;
    font-weight: 700;
    line-height: 1.25;
    color: #000000;
    text-align: center;
    font-family: CustomArial;
    text-transform: uppercase;
  }

  .break-var29 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
    &--black-var29 {
      background-color: black;
    }
  }
  .left-text-var29, .right-text-var29 {
    position: absolute;
    width: 100%;
    padding: 0 10px;
    bottom: 83px;
    font-size: 40px;
    line-height: 1.2;
    text-align: center;
    color: #000;
    font-weight: 400;
    font-family: CustomArial;
    &--top-var29 {
      bottom: auto;
      top: 83px;
    }
    p {
      background-color: white;
      display: inline-block;
      margin: 0;
      padding: 39px 46px 38px;
    }
    p.custom-brakes-var29 {
      white-space: nowrap;
    }
  }

  .left-text__divider-var29 {
    padding: 0 13px 0 7px;
  }

  .right-text__divider-var29 {
    padding: 0 7px 0 13px;
  }

  .image-var29 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .watermark-var29 {
    position: absolute;
    bottom: 30px;
    right: 36px;
  }
  .left-actual-photo-var29 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .left-actual-photo-var29--top {
    top: 0;
    bottom: auto;
  }
  .right-actual-photo-var29 {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 72px;
  }
  .right-actual-photo-var29--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
